// apiConfig.js

// const API_BASE_URL = 'http://localhost/kirana_manage/';
// const Inventory_api = 'http://localhost/kirana_manage/inventory/';
// const Customer_api = 'http://localhost/kirana_manage/customer/';
// const billing_api = 'http://localhost/kirana_manage/billing/';
// const Dashboard_api = 'http://localhost/kirana_manage/dashboard/'
// const Supplier_api = 'http://localhost/kirana_manage/supplier/'
// const verifyCode_api = 'http://localhost/kirana_manage/verification/'
// const contactus_api = 'http://localhost/kirana_manage/Contact_US_Queries/'
// const profile_api = 'http://localhost/kirana_manage/profile/'

const API_BASE_URL = 'http://shoppegrow.com/API/';
const Inventory_api = 'http://shoppegrow.com/API/inventory/';
const Customer_api = 'http://shoppegrow.com/API/customer/';
const billing_api = 'http://shoppegrow.com/API/billing/';
const Dashboard_api = 'http://shoppegrow.com/API/dashboard/'
const Supplier_api = 'http://shoppegrow.com/API/supplier/'
const verifyCode_api = 'http://shoppegrow.com/API/verification/'
const contactus_api = 'http://shoppegrow.com/API/Contact_US_Queries/'
const profile_api = 'http://shoppegrow.com/API/profile/'


export { API_BASE_URL, Inventory_api, Customer_api, billing_api, Dashboard_api, Supplier_api, verifyCode_api, contactus_api, profile_api };
